import { TourModel } from 'api-hooks/tour/tour-list/tour-detail';

export default function defaultValuesTour(data: TourModel) {
  return {
    code: data.code,
    id: data.id,
    transactionAt: data.transactionAt,
    name: data.name,
    description: data.description,
    startedAt: data.startedAt,
    endedAt: data.endedAt,
    day: data.day,
    night: data.night,
    status: data.status,
    tourFlights: (data.tourFlights || []).map((item) => ({
      refId: item.id,
      name: item.name,
      note: item.note,
      tourFlightAirlines: (item.tourFlightAirlines || []).map((airline) => ({
        airlineName: airline.airline.name,
        detail: airline.detail,
        preferenceName: airline.preference?.name ?? '',
        id: airline.id,
        price: airline.price,
        route: airline.route,
        time: airline.time,
        date: airline.date,
      })),
    })),
    tourHotels: (data.tourHotels || []).map((item) => ({
      refId: item.id,
      hotelName: item.hotel.name,
      note: item.note,
      details: (item.details || []).map((hotelTourItem) => ({
        checkIn: hotelTourItem.checkIn,
        checkOut: hotelTourItem.checkOut,
        cityTax: hotelTourItem.cityTax,
        description: hotelTourItem.description,
        night: hotelTourItem.night,
        hotelRoomName: `${hotelTourItem.hotelRoom.type} (${hotelTourItem.hotelRoom.size})`,
      })),
    })),
    tourProducts: (data.tourProducts || []).map((item) => ({
      refId: item.id,
      productVariantName: item.completeName,
      stock: item.productVariant.stock,
      qty: item.qty,
      avgCogs: (item.qty || 0) * (item.productVariant.sellPrice || 0),
      description: item.description,
    })),
  };
}
